import { render } from "./CollapseButton.vue?vue&type=template&id=cc0c4782"
import script from "./CollapseButton.vue?vue&type=script&lang=js"
export * from "./CollapseButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CollapseButton.vue"]])

export default __exports__